module.exports = require("./zh-Hans-SG.js");